module.exports = __webpack_public_path__ + "static/img/7areaB_01.1b236ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_01.png
// module id = 1213
// module chunks = 1